import { OverlayComponent } from '@qsp-ui-library/components/overlay/overlay.component';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { QimaSpinnerModule, QimaThreeSquaresLoaderModule } from '@qima/ngx-qima';

@NgModule({
  declarations: [OverlayComponent],
  exports: [OverlayComponent],
  imports: [CommonModule, QimaThreeSquaresLoaderModule, QimaSpinnerModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OverlayModule {}
